<template>
  <router-link v-if="to" :to="to"
               :tabindex="disabled?-1:tabIndex"
               :class="{'c-button-blue':true,'-small':small,'-medium':medium, '-full':full, '-vertical-arrow':isVertical,'-arrow':arrow,'-disabled':disabled, '-width-large':large}">
    <span :class="{'label -pen':!labelNormal, 'label':labelNormal}" :name="name"><slot></slot></span>
  </router-link>
  <a v-else
     @keyup.enter="!disabled?emit('click', 'enter'):''"
     :tabindex="disabled?-1:tabIndex"
     :class="{'c-button-blue':true,'-small':small,'-medium':medium, '-full':full, '-vertical-arrow': isVertical,'-arrow':arrow,'-disabled':disabled, '-width-large':large}"
     :name="name"
     @pointerdown="handleClick($event)">
    <span :class="{'label -pen':!labelNormal, 'label':labelNormal}"><slot></slot></span>
  </a>
</template>

<script setup lang="ts">

  withDefaults(
    defineProps<{
      to?: string;
      full?: boolean;
      small?: boolean;
      medium?: boolean;
      arrow?: boolean;
      isVertical?: boolean;
      labelNormal?: boolean;
      disabled?: boolean;
      tabIndex?: number;
      name?: string;
      large?: boolean;
    }>(),
    {
      full: false,
      small: false,
      medium: false,
      arrow: false,
      isVertical: false,
      labelNormal: false,
      disabled: false,
      tabIndex: 0,
      name: '',
      large: false,
    }
  );

  const emit = defineEmits<{
    (e: 'click', id: string): void
  }>()

  function handleClick(event: PointerEvent){
    if(event.pointerType === "mouse"){
      // NFR-4337対応：@pointerdownイベントが発生する時、type:mouseはその後に自動的にフォーカスが外れてしまうので遅延処理を入れて防ぐ
      setTimeout(() => {
        emit("click", event.pointerType)
      }, 5);
    }else{
      emit("click", event.pointerType)
    }
  }
</script>
